export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>下拉式阅读 · 弹窗阅读 · 翻页阅读</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
              YY漫画 · 你的全能免费漫画阅读器
            </h1>

            <p className="mt-4 text-base md:text-lg text-foreground-600 font-medium">
              韩漫日漫全集追更，三种阅读方式随心切换
            </p>

            <div className="mt-6 space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                YY漫画是一个专注于漫画阅读的免费平台，提供下拉式阅读、弹窗阅读和翻页阅读三种模式，支持高清画质显示。无论你喜欢韩漫的细腻画风还是日漫的热血剧情，这里都有完整的中文资源库等你探索。
              </p>
              <p>
                每天实时追更热门连载，收藏你心爱的作品，不错过任何更新。从经典名作到最新番剧，YY漫画为你打造最舒适的线上漫画阅读体验。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-600">10,000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">持续追更</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-600">三种模式</div>
                <div className="text-xs text-foreground-500 mt-1">自由切换</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-10">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-background-300 hover:border-primary-400 text-foreground-700 hover:text-primary-600 font-bold text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line text-lg"></i>
                了解功能
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-400/20 to-accent-400/20 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20manga%20comic%20reading%20app%20interface%20with%20vibrant%20illustration%20style%2C%20warm%20orange%20and%20coral%20accent%20colors%2C%20clean%20UI%20design%2C%20Japanese%20and%20Korean%20comic%20art%20elements%20visible%20on%20screen%2C%20floating%20device%20on%20light%20cream%20background%2C%20soft%20warm%20lighting%2C%20modern%20product%20photography%20style%2C%20editorial%20quality%2C%20minimal%20composition%20with%20plenty%20of%20negative%20space%20around%20the%20device&width=1000&height=1200&seq=hero-comic-reader-01&orientation=portrait"
                alt="YY漫画阅读器 - 支持下拉式、弹窗、翻页三种阅读模式的漫画APP界面"
                title="YY漫画阅读器界面展示"
                className="relative z-10 w-full max-w-[380px] lg:max-w-[440px] mx-auto rounded-3xl object-cover"
                style={{ aspectRatio: '5/6' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}